// Todas las carrocerias comparten estas prestaciones. La silueta y el tamano
// de su hitbox pueden variar, pero ninguna obtiene una ventaja de velocidad,
// aceleracion, masa, salto, agarre o nitro. Los nuevos autos heredan el mismo
// balance con solo incluir este perfil.
export const STANDARD_CAR_PERFORMANCE = Object.freeze({
  speed: 82,
  grip: 78,
  weight: 70,
  boost: 78,
  maxSpeed: 19,
  acceleration: 18,
  reverseSpeed: 8.2,
  handling: 1.9,
  traction: 9,
  mass: 1.1,
  boostForce: 25,
  cruiseTopSpeedMultiplier: 1.16,
  boostTopSpeedMultiplier: 1.36,
});

// Los canones tambien son cosmeticos desde el punto de vista competitivo.
// Esta unica regla gobierna todos los proyectiles, incluidos los de futuros
// canones que se agreguen al catalogo.
export const STANDARD_CANNON_PERFORMANCE = Object.freeze({
  projectileSpeed: 28,
  projectileLife: 2.2,
  projectileRadius: .12,
});

export const GAME_MODE_RULES = Object.freeze({
  practice: Object.freeze({
    projectileDamage: 20,
    respawnDelay: 3,
    respawnProtection: 0,
    fuseRespawnDelay: 1.25,
    aiShotDistance: 19,
    aiShotAngle: .18,
    aiFireDelay: .52,
    aiFireJitter: .55,
  }),
  chase: Object.freeze({
    duration: 120,
    projectileDamage: 0,
    tagProtectionInitial: 1.4,
    tagProtection: 1.05,
    instabilityPerHit: 28,
    instabilityDecay: 9,
    pressureHold: 1.05,
    hitCooldown: .16,
    instabilityThreshold: 100,
    pursuedImpulse: 1.75,
    pursuedLift: .28,
    defensiveImpulse: 3.1,
    defensiveLift: .48,
    nitroLockDuration: 1.35,
    pursuedSlowDuration: .85,
    defensiveSlowDuration: 1.2,
    slowAccelerationScale: .78,
    slowTopSpeedScale: .9,
    slowSteeringScale: .88,
    aiShotDistance: 20,
    aiShotAngle: .3,
    aiFireDelay: .4,
    aiFireJitter: .45,
    pursuedSpeedScale: .98,
    chaserSpeedScale: 1.08,
    chaserDistanceBonus: .16,
    chaserAccelerationScale: 1.08,
  }),
  battle: Object.freeze({
    duration: 180,
    killLimit: 15,
    projectileDamage: 20,
    respawnDelay: 3,
    respawnProtection: 1.4,
    aiShotDistance: 22,
    aiShotAngle: .34,
    aiFireDelay: .28,
    aiFireJitter: .34,
  }),
  ffa: Object.freeze({
    duration: 180,
    killLimit: 15,
    projectileDamage: 20,
    respawnDelay: 3,
    respawnProtection: 1.4,
    aiShotDistance: 22,
    aiShotAngle: .34,
    aiFireDelay: .28,
    aiFireJitter: .34,
  }),
  rupture: Object.freeze({
    projectileDamage: 0,
    respawnDelay: 9999,
    respawnProtection: 0,
    fuses: 2,
    combatDuration: 10,
    warningDuration: 2,
    transferDuration: 2,
    collapseDuration: 1.8,
    settleDuration: 1,
    powerupRefreshDelay: 5,
    finalWarningDuration: 3,
    finalRingDuration: 1.45,
    minimumTransferNitro: 70,
    landingNitro: 28,
    landingProtection: 0,
    instabilityPerProjectile: 18,
    instabilityDecay: 6,
    instabilityHold: 1.35,
  }),
});

export const CARS = [
  {
    id: 'muscle',
    name: 'Rojo Bravo',
    className: 'Muscle',
    description: 'Un clásico del 69, potente y ancho.',
    color: '#f04c0c',
    accent: '#fff4e4',
    defaultWheelId: 'chrome_classic',
    defaultEngineSoundId: 'muscle_rumble',
    defaultCannonId: 'dart_cannon',
    defaultProjectileId: 'toy_dart',
    defaultNitroId: 'turbo_blue',
    defaultExplosionId: 'toy_blast',
    defaultTombstoneId: 'classic_marker',
    ...STANDARD_CAR_PERFORMANCE,
  },
  {
    id: 'sport',
    name: 'Rayo Nova',
    className: 'Sport',
    description: 'Ligero, veloz y pegado a cada curva.',
    color: '#386ff2',
    accent: '#55e3ff',
    defaultWheelId: 'turbine_blue',
    defaultEngineSoundId: 'sport_whine',
    defaultCannonId: 'twin_darts',
    defaultProjectileId: 'twin_stinger',
    defaultNitroId: 'plasma_pink',
    defaultExplosionId: 'plasma_pop',
    defaultTombstoneId: 'holo_marker',
    ...STANDARD_CAR_PERFORMANCE,
  },
  {
    id: 'hotrod',
    name: 'Fuego Loco',
    className: 'Hot Rod',
    description: 'Motor enorme, actitud aún más grande.',
    color: '#ef762f',
    accent: '#ffe059',
    defaultWheelId: 'five_star',
    defaultEngineSoundId: 'hotrod_chop',
    defaultCannonId: 'mega_pop',
    defaultProjectileId: 'plasma_bubble',
    defaultNitroId: 'hot_flames',
    defaultExplosionId: 'firework_boom',
    defaultTombstoneId: 'classic_marker',
    ...STANDARD_CAR_PERFORMANCE,
  },
  {
    id: 'rally',
    name: 'Pampa XR',
    className: 'Rally',
    description: 'Agarre total sobre tierra, pasto o alfombra.',
    color: '#f0f1e9',
    accent: '#2fb775',
    defaultWheelId: 'rally_white',
    defaultEngineSoundId: 'rally_buzz',
    defaultCannonId: 'dart_cannon',
    defaultProjectileId: 'toy_dart',
    defaultNitroId: 'confetti_rush',
    defaultExplosionId: 'confetti_burst',
    defaultTombstoneId: 'toy_cone',
    ...STANDARD_CAR_PERFORMANCE,
  },
  {
    id: 'pickup',
    name: 'Mula 4x4',
    className: 'Pickup',
    description: 'Pesada, resistente y nacida para empujar.',
    color: '#43a661',
    accent: '#ffbd3d',
    defaultWheelId: 'offroad_beadlock',
    defaultEngineSoundId: 'truck_thump',
    defaultCannonId: 'twin_darts',
    defaultProjectileId: 'twin_stinger',
    defaultNitroId: 'hot_flames',
    defaultExplosionId: 'toy_blast',
    defaultTombstoneId: 'toy_cone',
    ...STANDARD_CAR_PERFORMANCE,
  },
  {
    id: 'van',
    name: 'Tostadora',
    className: 'Van',
    description: 'Un ladrillo adorable con sorpresas adentro.',
    color: '#8b65df',
    accent: '#ff6f94',
    defaultWheelId: 'toy_caps',
    defaultEngineSoundId: 'van_hum',
    defaultCannonId: 'mega_pop',
    defaultProjectileId: 'plasma_bubble',
    defaultNitroId: 'plasma_pink',
    defaultExplosionId: 'confetti_burst',
    defaultTombstoneId: 'holo_marker',
    ...STANDARD_CAR_PERFORMANCE,
  },
];

// Las ruedas son cosméticos independientes. Todas se construyen alrededor de
// un pivote, radio y ancho normalizados para poder montarlas en cualquier
// carrocería sin modificar su física ni sus puntos de anclaje.
export const WHEELS = [
  {
    id: 'chrome_classic',
    name: 'Cromo Clásico',
    description: 'Seis rayos anchos con acabado de muscle car.',
    color: '#d9dde2',
    accent: '#f5f7fa',
    spokes: 6,
    spokeWidth: .30,
    spokeHeight: .12,
    spokeLength: .58,
    inner: .39,
    rim: .55,
    rimOffset: -.12,
    hub: .28,
    tireRoundness: .34,
    tread: 0,
  },
  {
    id: 'turbine_blue',
    name: 'Turbina Nova',
    description: 'Doce rayos finos y aro celeste de competición.',
    color: '#cbd7e7',
    accent: '#42dff5',
    spokes: 12,
    spokeWidth: .17,
    spokeHeight: .085,
    spokeLength: .66,
    inner: .35,
    rim: .61,
    rimOffset: -.12,
    hub: .22,
    tireRoundness: .28,
    tread: 0,
  },
  {
    id: 'five_star',
    name: 'Cinco Estrellas',
    description: 'Cinco brazos profundos con centro cobrizo.',
    color: '#d7d9de',
    accent: '#e67632',
    spokes: 5,
    spokeWidth: .42,
    spokeHeight: .16,
    spokeLength: .62,
    inner: .36,
    rim: .58,
    rimOffset: -.12,
    hub: .31,
    tireRoundness: .38,
    tread: 0,
  },
  {
    id: 'rally_white',
    name: 'Rally Blanco',
    description: 'Ocho rayos robustos para tierra y alfombra.',
    color: '#f0eee6',
    accent: '#36b779',
    spokes: 8,
    spokeWidth: .27,
    spokeHeight: .13,
    spokeLength: .61,
    inner: .37,
    rim: .57,
    rimOffset: -.12,
    hub: .27,
    tireRoundness: .42,
    tread: 14,
  },
  {
    id: 'offroad_beadlock',
    name: 'Beadlock 4x4',
    description: 'Aro reforzado y tacos grandes para empujar fuerte.',
    color: '#717780',
    accent: '#ffbd3d',
    spokes: 6,
    spokeWidth: .35,
    spokeHeight: .15,
    spokeLength: .54,
    inner: .43,
    rim: .60,
    rimOffset: -.12,
    hub: .34,
    tireRoundness: .5,
    tread: 12,
  },
  {
    id: 'toy_caps',
    name: 'Tapas Pop',
    description: 'Cinco rayos suaves con centro de juguete.',
    color: '#e9e4f4',
    accent: '#ff6f94',
    spokes: 5,
    spokeWidth: .48,
    spokeHeight: .17,
    spokeLength: .49,
    inner: .44,
    rim: .52,
    rimOffset: -.12,
    hub: .38,
    tireRoundness: .4,
    tread: 0,
  },
];

export const CANNONS = [
  { id:'dart_cannon', name:'Dardo Clásico', description:'El lanzador de juguete original.', color:'#d9dde2', accent:'#ffcf43', style:'single', defaultProjectileId:'toy_dart', soundWave:'square', soundTone:520, soundDuration:.075, soundFilter:2200, soundNoiseGain:.025, soundToneGain:.075 },
  { id:'twin_darts', name:'Doble Dardo', description:'Dos tubos sincronizados sobre una base compacta.', color:'#cbd7e7', accent:'#42dff5', style:'twin', defaultProjectileId:'twin_stinger', soundWave:'sawtooth', soundTone:650, soundDuration:.09, soundFilter:2800, soundNoiseGain:.032, soundToneGain:.07 },
  { id:'mega_pop', name:'Mega Pop', description:'Cañón redondo y exagerado con depósito de cápsulas.', color:'#f0d7e5', accent:'#ff6f94', style:'bubble', defaultProjectileId:'plasma_bubble', soundWave:'sine', soundTone:360, soundDuration:.14, soundFilter:1450, soundNoiseGain:.018, soundToneGain:.09 },
  { id:'rail_stinger', name:'Aguijón Rail', description:'Rieles largos con una punta eléctrica.', color:'#777d8b', accent:'#9d76ff', style:'rail', defaultProjectileId:'rail_spike', soundWave:'triangle', soundTone:840, soundDuration:.11, soundFilter:4200, soundNoiseGain:.04, soundToneGain:.065 },
];

export const ENGINE_SOUNDS = [
  { id:'muscle_rumble', name:'Rugido Muscle', description:'Grave, irregular y con mucho cuerpo.', wave:'sawtooth', baseTone:52, speedPitch:7.4, boostPitch:44, filterType:'lowpass', filter:520, resonance:1.1, volume:.038, pulse:5.2, noiseGain:.006 },
  { id:'sport_whine', name:'Silbido Sport', description:'Agudo y limpio, sube rápido de vueltas.', wave:'triangle', baseTone:82, speedPitch:9.2, boostPitch:70, filterType:'bandpass', filter:1120, resonance:1.7, volume:.032, pulse:9, noiseGain:.003 },
  { id:'hotrod_chop', name:'Hot Rod Picado', description:'Pulsos graves de motor preparado.', wave:'square', baseTone:47, speedPitch:6.8, boostPitch:38, filterType:'lowpass', filter:460, resonance:1.3, volume:.036, pulse:7.5, noiseGain:.008 },
  { id:'rally_buzz', name:'Rally Nervioso', description:'Respuesta rápida con un zumbido mecánico.', wave:'sawtooth', baseTone:70, speedPitch:8.4, boostPitch:55, filterType:'bandpass', filter:920, resonance:1.4, volume:.034, pulse:11, noiseGain:.005 },
  { id:'truck_thump', name:'Golpe 4x4', description:'Motor pesado, bajo y contundente.', wave:'square', baseTone:42, speedPitch:6.1, boostPitch:34, filterType:'lowpass', filter:390, resonance:.9, volume:.041, pulse:4.3, noiseGain:.009 },
  { id:'van_hum', name:'Zumbido Van', description:'Suave, redondo y juguetón.', wave:'sine', baseTone:63, speedPitch:7.1, boostPitch:46, filterType:'lowpass', filter:680, resonance:.8, volume:.032, pulse:6.4, noiseGain:.004 },
];

export const PROJECTILES = [
  { id:'toy_dart', name:'Dardo Corona Turbo', description:'Dardo clásico equilibrado.', style:'dart', color:'#d9dde2', accent:'#ffcf43', scale:1, spin:8, travelWave:'triangle', travelTone:230, travelDuration:.24, travelFilter:1450, travelNoiseGain:.018, travelToneGain:.025, impactWave:'square', impactTone:330, impactDuration:.09, impactFilter:1850, impactNoiseGain:.07, impactToneGain:.08 },
  { id:'twin_stinger', name:'Aguijones Gemelos', description:'Dos puntas sincronizadas.', style:'twin', color:'#cbd7e7', accent:'#42dff5', scale:1, spin:11, travelWave:'sawtooth', travelTone:285, travelDuration:.28, travelFilter:2100, travelNoiseGain:.022, travelToneGain:.022, impactWave:'square', impactTone:410, impactDuration:.08, impactFilter:2600, impactNoiseGain:.065, impactToneGain:.072 },
  { id:'plasma_bubble', name:'Burbuja Plasma', description:'Orbe brillante con núcleo energético.', style:'bubble', color:'#f0d7e5', accent:'#ff6f94', scale:1, spin:4, travelWave:'sine', travelTone:410, travelDuration:.38, travelFilter:1250, travelNoiseGain:.012, travelToneGain:.035, impactWave:'sine', impactTone:260, impactDuration:.16, impactFilter:1180, impactNoiseGain:.055, impactToneGain:.095 },
  { id:'rail_spike', name:'Púa Rail', description:'Proyectil afilado de energía.', style:'rail', color:'#777d8b', accent:'#9d76ff', scale:1, spin:13, travelWave:'triangle', travelTone:520, travelDuration:.22, travelFilter:3600, travelNoiseGain:.028, travelToneGain:.022, impactWave:'sawtooth', impactTone:460, impactDuration:.12, impactFilter:3300, impactNoiseGain:.075, impactToneGain:.07 },
];

export const NITRO_EFFECTS = [
  { id:'turbo_blue', name:'Turbo Azul', description:'Llama celeste con núcleo amarillo.', color:'#5ef3ff', accent:'#ffef75', spark:'#66eaff', style:'flame' },
  { id:'hot_flames', name:'Fuego Caliente', description:'Estela naranja y roja de hot rod.', color:'#ff713d', accent:'#ffd45b', spark:'#ff8a42', style:'flame' },
  { id:'plasma_pink', name:'Plasma Pop', description:'Propulsión violeta con destellos rosados.', color:'#b56cff', accent:'#ff77c8', spark:'#db78ff', style:'plasma' },
  { id:'confetti_rush', name:'Fiesta Turbo', description:'Una estela multicolor de juguete.', color:'#39d9ee', accent:'#ff4f7f', spark:'#ffd83d', style:'confetti' },
];

export const DEATH_EXPLOSIONS = [
  { id:'toy_blast', name:'Explosión Corona Turbo', description:'Piezas amarillas y naranjas salen disparadas.', color:'#ffd83d', accent:'#ff742f', style:'burst' },
  { id:'plasma_pop', name:'Burbuja de Plasma', description:'Una onda violeta se rompe en partículas.', color:'#a66cff', accent:'#55e3ff', style:'plasma' },
  { id:'firework_boom', name:'Fuegos Artificiales', description:'Chispas calientes en forma de estrella.', color:'#ff643f', accent:'#ffe059', style:'firework' },
  { id:'confetti_burst', name:'Lluvia de Confeti', description:'Una eliminación festiva y multicolor.', color:'#ff4f7f', accent:'#39d9ee', style:'confetti' },
];

export const TOMBSTONES = [
  { id:'classic_marker', name:'Lápida Clásica', description:'Marcador de juguete con placa metálica.', color:'#6f7180', accent:'#d9dde2', style:'stone', soundWave:'triangle', soundTone:180, soundDuration:.55, soundFilter:780, soundNoiseGain:.055, soundToneGain:.065 },
  { id:'toy_cone', name:'Cono Caído', description:'Un cono de tránsito marca el lugar.', color:'#ff7a2f', accent:'#fff1d0', style:'cone', soundWave:'square', soundTone:260, soundDuration:.38, soundFilter:1350, soundNoiseGain:.04, soundToneGain:.055 },
  { id:'holo_marker', name:'Holograma KO', description:'Un marcador luminoso con señal de KO.', color:'#44366f', accent:'#55e3ff', style:'holo', soundWave:'sine', soundTone:420, soundDuration:.72, soundFilter:2100, soundNoiseGain:.018, soundToneGain:.075 },
  { id:'block_marker', name:'Bloque Memorial', description:'Bloques encastrables forman una pequeña cruz.', color:'#efc13c', accent:'#ef5c67', style:'blocks', soundWave:'square', soundTone:210, soundDuration:.44, soundFilter:980, soundNoiseGain:.048, soundToneGain:.062 },
];

export const COSMETIC_SLOTS = Object.freeze([
  { id:'wheelId', label:'Ruedas', icon:'◉', catalog:WHEELS },
  { id:'engineSoundId', label:'Motor', icon:'♫', catalog:ENGINE_SOUNDS },
  { id:'cannonId', label:'Cañones', icon:'➤', catalog:CANNONS },
  { id:'projectileId', label:'Proyectiles', icon:'◆', catalog:PROJECTILES },
  { id:'nitroId', label:'Nitro', icon:'✦', catalog:NITRO_EFFECTS },
  { id:'explosionId', label:'Explosión', icon:'✹', catalog:DEATH_EXPLOSIONS },
  { id:'tombstoneId', label:'Lápida', icon:'†', catalog:TOMBSTONES },
]);

export const MAPS = [
  {
    id: 'living',
    name: 'Living gigante',
    shortName: 'LIVING',
    description: 'Alfombra, sillones, mesa ratona y una TV enorme.',
    color: '#d78361',
  },
  {
    id: 'bedroom',
    name: 'Cuarto en caos',
    shortName: 'HABITACIÓN',
    description: 'Juguetes, bloques, cama y obstáculos desparramados.',
    color: '#5c8cc7',
  },
  {
    id: 'garden',
    name: 'Jardín salvaje',
    shortName: 'JARDÍN',
    description: 'Pasto, tierra, piedras y adornos a escala colosal.',
    color: '#62a55a',
  },
];

export const RUPTURE_MAPS = [
  {
    id: 'rupture-void',
    name: 'Salto al vacío',
    shortName: 'VACÍO TURBO',
    description: 'Islas suspendidas sin paredes ni suelo debajo. Llegar al próximo piso es sobrevivir.',
    color: '#7555c9',
  },
  {
    id: 'rupture-storm',
    name: 'Tormenta de juguetes',
    shortName: 'TORMENTA TURBO',
    description: 'Una ruta ascendente entre nubes eléctricas, rayos y turbinas gigantes.',
    color: '#28c8c7',
  },
];

export const BOT_DIFFICULTIES = Object.freeze([
  {
    id:'basic',
    name:'Básica',
    shortName:'BÁSICA',
    description:'Reacciones tranquilas, puntería amplia y conducción más permisiva.',
    aimLead:.16,
    aimAngleScale:1,
    fireDelayScale:1,
    routeRefreshScale:1,
    steeringGain:1.7,
    edgeLookAhead:.58,
    edgeClearance:1.38,
    patrolThrottle:.44,
    transferGuidance:3.7,
    transferMaximumSpeed:18.5,
    transferReadyWindow:1.25,
  },
  {
    id:'medium',
    name:'Media',
    shortName:'MEDIA',
    description:'Toma mejores líneas, usa el nitro con criterio y dispara con mayor precisión.',
    aimLead:.22,
    aimAngleScale:.86,
    fireDelayScale:.82,
    routeRefreshScale:.78,
    steeringGain:1.86,
    edgeLookAhead:.74,
    edgeClearance:1.52,
    patrolThrottle:.54,
    transferGuidance:4.15,
    transferMaximumSpeed:18.5,
    transferReadyWindow:1.55,
  },
  {
    id:'hard',
    name:'Difícil',
    shortName:'DIFÍCIL',
    description:'Anticipa movimientos, protege mejor los bordes y aprovecha cada oportunidad.',
    aimLead:.28,
    aimAngleScale:.72,
    fireDelayScale:.68,
    routeRefreshScale:.62,
    steeringGain:2,
    edgeLookAhead:.92,
    edgeClearance:1.66,
    patrolThrottle:.64,
    transferGuidance:4.6,
    transferMaximumSpeed:18.5,
    transferReadyWindow:1.82,
  },
]);

export const getCar = (id) => CARS.find((car) => car.id === id) || CARS[0];
export const getWheel = (id) => WHEELS.find((wheel) => wheel.id === id) || WHEELS[0];
export const getEngineSound = (id) => ENGINE_SOUNDS.find((item) => item.id === id) || ENGINE_SOUNDS[0];
export const getCannon = (id) => CANNONS.find((item) => item.id === id) || CANNONS[0];
export const getProjectile = (id) => PROJECTILES.find((item) => item.id === id) || PROJECTILES[0];
export const getNitroEffect = (id) => NITRO_EFFECTS.find((item) => item.id === id) || NITRO_EFFECTS[0];
export const getDeathExplosion = (id) => DEATH_EXPLOSIONS.find((item) => item.id === id) || DEATH_EXPLOSIONS[0];
export const getTombstone = (id) => TOMBSTONES.find((item) => item.id === id) || TOMBSTONES[0];
export const getMap = (id) => MAPS.find((map) => map.id === id) || MAPS[0];
export const getRuptureMap = (id) => RUPTURE_MAPS.find((map) => map.id === id) || RUPTURE_MAPS[0];
export const getBotDifficulty = (id) => BOT_DIFFICULTIES.find((item) => item.id === id) || BOT_DIFFICULTIES[0];
